import React, { Component } from "react";
import { Accessor, ColorX, LocaleX } from "IZOX/STATIC";
import { VStack, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";

/**
 * @augments {Component<Props, State>}
 */
class PVerifying extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PVerifying.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(PVerifying.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("Grass")} fullHeight VAlign="-" spacing={20}>
        <XText fontSize={32} color={ColorX.CSS("pureWhite")}>
          {LocaleX.Parse({
            EN: "Your account cannot be authenticated.",
            TC: "您的帳戶無法認證"
          })}
        </XText>
        <XText fontSize={16} color={ColorX.CSS("pureWhite")}>
          {LocaleX.Parse({
            EN: "Please contact customer service, or try again later.",
            TC: "請聯絡客戶服務，或稍後再試。"
          })}
        </XText>
      </VStack>
    );
  }

}

export default PVerifying;
